import { post as axiosPost } from '@/security/Axios';
import ApiErrorHandler       from './ApiErrorHandler';
import { API_BASE_URL }      from '@/constants/ApiConstant';
import { AXIOS_BASE_URL }    from '@/security/Axios';

/* ------------ existing helpers (unchanged) ------------ */

export function fileUpload(data, folderName) {
  const formData = new FormData();
  if (data !== '') {
    Object.keys(data).forEach(key => formData.append(key, data[key]));
  }

  return (dispatch) =>
    new Promise((resolve, reject) => {
      // Use relative URL since axios already has baseURL configured
      // This prevents double /api/api issue
      axiosPost(
        `/file/upload/${folderName}`,
        formData,
        { Accept: 'multipart/form-data', 'Content-Type': 'multipart/form-data' }
      )
        .then(res  => resolve(res))
        .catch(err => reject(ApiErrorHandler(err)));
    });
}

export function getFileUrl(fileName, folderName) {
  // Handle undefined or empty filename
  if (!fileName || fileName === 'undefined' || fileName === 'null' || fileName.trim() === '') {
    return ''; // Return empty string to prevent invalid URLs
  }
  
  // Use AXIOS_BASE_URL if available (runtime resolved), otherwise fall back to API_BASE_URL
  const base = (typeof AXIOS_BASE_URL !== 'undefined' && AXIOS_BASE_URL) 
    ? AXIOS_BASE_URL 
    : (API_BASE_URL || '');
  
  // Ensure base doesn't have trailing slash and encode filename
  const cleanBase = base.replace(/\/$/, '');
  const encodedFileName = encodeURIComponent(fileName);
  return `${cleanBase}/file/get/${folderName}/${encodedFileName}`;
}

/* ------------ NEW helper for signed / encoded URLs ------------ */

/**
 * Build a URL that is
 *   • browser‑safe (fileName is encodeURIComponent’ed)
 *   • optionally signed with a token query param (?tk=...).
 *
 * Nothing else in the app is forced to use this helper.
 */
export function getFileUrlSigned(fileName, folderName) {
  // Handle undefined or empty filename
  if (!fileName || fileName === 'undefined' || fileName === 'null' || fileName.trim() === '') {
    return '';
  }
  
  const encoded = encodeURIComponent(fileName);
  // Use AXIOS_BASE_URL if available (runtime resolved), otherwise fall back to API_BASE_URL
  const base = (typeof AXIOS_BASE_URL !== 'undefined' && AXIOS_BASE_URL) 
    ? AXIOS_BASE_URL 
    : (API_BASE_URL || '');
  const cleanBase = base.replace(/\/$/, '');
  const url = `${cleanBase}/file/get/${folderName}/${encoded}`;

  // whichever storage you already use for the logged‑in admin token:
  const token =
      localStorage.getItem('adminToken') ??
      sessionStorage.getItem('adminToken') ??
      '';

  return token ? `${url}?tk=${token}` : url;
}
